<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">ダウンロード</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!this.yearMonth" @click="exportCsv()"
          >ダウンロード</v-btn
        >
        <v-btn @click="dialog = false">戻る</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-layout>
          <v-flex md12 sm6 xs12>
            <date-picker
              label="月次"
              type="month"
              v-model="yearMonth"
            ></date-picker>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['employee', 'dif'],
  data() {
    return {
      yearMonth: null,
      query: {},
      dialog: false,
    }
  },
  methods: {
    popup() {
      this.dialog = true
    },
    exportCsv() {
      if (this.dif) {
        this.$download('/warehouse-container-settings/forecasts-master/xlsx', {
          yearMonth: this.yearMonth,
          buId: (this.employee && this.employee.buId) || null,
        })
      } else {
        this.$http
          .get(`/warehouse-container-settings`, {
            params: {
              ...this.query,
              yearMonth: this.yearMonth,
              buId: (this.employee && this.employee.buId) || null,
            },
          })
          .then((res) => {
            console.log(res.data)

            var showResults = []

            var dateRange = []
            res.data
              .map((r) => r.date)
              .forEach((r) => {
                if (dateRange.indexOf(r) === -1) {
                  dateRange.push(r)
                }
              })
            console.log(dateRange)

            dateRange = dateRange.sort((d1, d2) => d1.localeCompare(d2))
            console.log(dateRange)

            var groupedData = this.groupBy(res.data, function(item) {
              return [
                item.warehouseId,
                item.buId,
                item.businessUnitId,
                item.productGroupName,
              ]
            })

            groupedData.forEach((data) => {
              var sortedData = data.sort((a, b) => {
                return this.$sortByProps(a, b, {
                  date: 'asc',
                })
              })
              var newObject = {
                warehouseCode: data[0].warehouseCode,
                warehouseName: data[0].warehouseName,
                buCode: data[0].buCode,
                buName: data[0].companyName || data[0].buName,
                businessUnitCode: data[0].businessUnitCode,
                businessUnitName: data[0].businessUnitName,
                productGroupName: data[0].productGroupName,
              }

              dateRange.forEach((d) => {
                var setting = sortedData.find((s) => s.date === d)
                newObject[d] = (setting && setting.upperLimit) || 0
              })

              // sortedData.forEach((s) => {
              //   newObject[s.date] = s.upperLimit || 0
              // })
              showResults.push(newObject)
              console.log(newObject)
            })

            let headers = [
              'warehouseCode',
              'warehouseName',
              'buCode',
              'buName',
              'businessUnitCode',
              'businessUnitName',
              'productGroupName',
            ].concat(dateRange)

            let showHeaders = [
              '納入場所Code',
              '納入場所',
              '事業本部Code',
              '事業本部',
              'BU Code',
              'BU',
              '品種グループ',
            ].concat(dateRange)

            this.$exportTable(
              showResults,
              headers,
              showHeaders,
              'warehouse-service'
            )
          })
      }
    },
    groupBy(array, f) {
      let groups = {}
      array.forEach(function(o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function(group) {
        return groups[group]
      })
    },
  },
}
</script>

<style></style>
